import React from 'react'
import { MdArrowBackIosNew } from "react-icons/md";
import salatTasbeeh from "../Images/salat-tasbeeh.webp";
import salatTasbeeh2 from "../Images/shab2.webp";

function ShabeBarat() {
  return (
    <div className='contain'>
        <div className="page-header">
          <span className="backBtn" onClick={()=> window.history.back()}>
            <MdArrowBackIosNew />
          </span>
          <div className="page-header__content">
            <h1 className="pagetitle">Shabe Barat Ki Fazilat</h1>
          </div>
       </div>
       <div className="contentSection-card">
            <p className="contentSection_title--content">
            Huzur Nabi-E-Kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad farmaya ki : 
            “ Allah Paak Shaban ki 15vi shab me apni tamam makhlooq ki taraf 
            nazre rahmat farmata hai fir Mushrik aur (musalman se ) Dushmani 
            rakhne wale ke siwa sari makhlooq ki maghfirat farma deta hai. ”
            </p>
            <span className="referenceTag">[ Ibne Majah : 1390 ]</span>

            <h3 className="contentSection_subtitle">Shab-E-Barat ki Fazilat ki Haqeeqat :</h3>
            <p className="contentSection_title--content">
                Shabe Barat ke bare me ye kahna bilkul galat hai ki iski koi 
                fazilat hadees se sabit nahi hai, haqeeqat ye hai ki 
                10 صحابہ کرام رضوان اللہ علیہم اجمعین se ahaadees marwi hain,
                 jisme Nabi kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne is raat ki fazilat
                  bayan farmayi, unme se baaz(kuch) ahaadees sanad ke aetabaar se beshak
                   kuch kamzor hain aur un ahadees ke kamzor hone ki wajah se kuch ulama
                    ne ye kah diya ki is raat ki fazilat be-asl hai. lekin hazraate Muhaddiseen 
                    aur fuqaha ka ye faisla hai ki agar ek riwayat sanad ke aetabar se kamzor
                     ho lekin uski tayyed (support) bahut si ahaadees se ho jaye to uski kamzori 
                     door ho jati hai. [the decision of the muhaddithin and jurists is that if a
                      narration is weak in terms of authenticity but it is supported by many 
                      ahaadeeth, then its weakness is removed.]
            </p>

            <div className='nafl_namaze__section'>
                  <h3 className="contentSection_subtitle" style={{fontSize:'22px'}}>Nafl Namaze</h3>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>2 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>तहीय्यत उल वुजू</strong> की नमाज़:</span>
                        <span><strong>रकअतें: </strong> 2 रकअत नफिल </span>
                        <span className='nafl_namaze__failat'><strong> तरीका :  </strong> 2 रकअत नफिल नमाज की नियत करें।
                          हर रकअत में सूरह फातिहा के बाद कोई भी सूरह पढ़ें।
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>2 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>सलातुत तौबा </strong> की नमाज़:</span>
                        <span><strong>रकअतें: </strong> 2 रकअत नफिल </span>
                        <span className='nafl_namaze__failat'><strong> तरीका :  </strong> 2 रकअत नफिल नमाज की नियत करें।
                          हर रकअत में सूरह फातिहा के बाद कोई भी सूरह पढ़ें।
                          नमाज खत्म होने के बाद अल्लाह से दिल से अपने गुनाहों की माफी मांगें और तौबा करें।
                          दुआ में अल्लाह से अपनी गलतियों को माफ करने और सीधे रास्ते पर चलने की हिदायत मांगें।
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>2 या 4 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>सलातुल हाजत </strong> की नमाज़:</span>
                        <span><strong>रकअतें: </strong> 2 या 4 रकअत नफिल। </span>
                        <span className='nafl_namaze__failat'><strong> तरीका :  </strong> 2 रकअत नफिल नमाज की नियत करें।
                          हर रकअत में सूरह फातिहा के बाद कोई भी सूरह पढ़ें।
                          नमाज खत्म होने के बाद अल्लाह की हम्द-ओ-सना (तारीफ) करें।
                          फिर अपनी जरूरत, हाजत के लिए दिल से दुआ करें।
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>4 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>सलातुत तसबीह </strong> की नमाज़:</span>
                        <span><strong>रकअतें: </strong> 4 रकअत नफिल। </span>
                        <span className='nafl_namaze__failat'><strong> तरीका :  </strong> Neeche attached image me dekhe.
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>Min. 2 Max. 12 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>तहज्जुद </strong> की नमाज़:</span>
                        <span><strong>रकअतें: </strong>Min. 2 Max. 12 रकत रकअत नफिल। </span>
                        <span className='nafl_namaze__failat'><strong> तरीका :  </strong> 2 रकअत नफिल नमाज की नियत करें।
                          हर रकअत में सूरह फातिहा के बाद कोई भी सूरह पढ़ें।
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>दुरूद शरीफ़</span>
                      <div className='nafl_namaze__description'>
                        <span>Minimum 1000 times</span>
                        <span className='nafl_namaze__failat'>
                        इसके अलावा <b>क़ज़ा ए उमरी</b>, सूरह यासीन, सूरह मुल्क, सूरह रहमान, सूरह मुज़म्मिल, इस्तिग़फ़ार (अस्तग़फिरुल्लाह) और कलमा शरीफ पढ़ सकते हैं ! जिस क़द्र आप नफ़्ल नमाज़ पढ़ सके वो पढ़े !
                        </span>
                      </div>
                  </div>
                  {/* <div className='nafl_namaze__item contentSection-card'>
                      <span>2 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>तरकीबः </strong>हर रकत में <strong>सूरह फातिहा (अलहम्दु शरीफ)</strong> के बाद <strong> 1 बार आयतल कुर्सी 
                        </strong> और       
                        <strong> 15 बार  सूरह इखलास (कुलहुवल्लाहु अहद) </strong>पढ़े ! सलाम फेरने के बाद 100 बार दुरुद शरीफ पढ़े !</span>
                        <span className='nafl_namaze__failat'> <strong> फज़ीलत : </strong> रोज़ी में बरकत होगी, रंज व गम से नजात, गुनाहों की बख़्शिश, 
                        मग़फिरत होगी ! 
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>8 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>तरकीबः ( दो-दो रकत करके पढ़े ) : </strong>हर रकत में <strong>सूरह फातिहा (अलहम्दु शरीफ)</strong> के बाद 
                        <strong>  5 बार  सूरह इखलास (कुलहुवल्लाहु अहद) </strong>पढ़े !</span>
                        <span className='nafl_namaze__failat'> <strong> फज़ीलत : </strong> गुनाहों से पाक व साफ होगा, दुआएँ कुबूल होगी, सवाबे अज़ीम 
                           होगा ! 
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>12 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>तरकीबः ( दो-दो रकत करके पढ़े ) : </strong>हर रकत में <strong>सूरह फातिहा (अलहम्दु शरीफ)</strong> के बाद 
                        <strong> 10 बार  सूरह इखलास (कुलहुवल्लाहु अहद) </strong>पढ़े ! सलाम फेरने के बाद 10 बार कलमा-ए-तौहीद (चौथा कलमा), 10 बार 
                         कलमा-ए-तमजीद (तीसरा कलमा) और   
                          10 बार दुरुद शरीफ पढ़े ! 
                          </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>14 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>तरकीबः ( दो-दो रकत करके पढ़े ) : </strong>हर रकत में <strong>सूरह फातिहा (अलहम्दु शरीफ)</strong> के बाद 
                        <strong> कोई भी सूरह ( जो आपको याद हो ) </strong>पढ़े !</span>
                      <span className='nafl_namaze__failat'> <strong> फज़ीलत : </strong> जो भी दुआ मांगेंगे, कुबूल होगी ! (इंशा अल्लाह)
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>4 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>तरकीबः ( दो-दो रकत करके पढ़े ) : </strong>हर रकत में <strong>सूरह फातिहा (अलहम्दु शरीफ)</strong> के बाद 
                        <strong>  50 बार  सूरह इखलास (कुलहुवल्लाहु अहद) </strong>पढ़े !</span>
                        <span className='nafl_namaze__failat'> <strong> फज़ीलत : </strong>गुनाहों से ऐसे पाक हो जायेगा जैसे अभी पैदा हुआ हो !
                        </span>
                      </div>
                  </div>
                  <div className='nafl_namaze__item contentSection-card'>
                      <span>8 रकत  </span>
                      <div className='nafl_namaze__description'>
                        <span><strong>तरकीबः ( दो-दो रकत करके पढ़े ) : </strong>हर रकत में <strong>सूरह फातिहा (अलहम्दु शरीफ)</strong> के बाद 
                        <strong>  11 बार  सूरह इखलास (कुलहुवल्लाहु अहद) </strong>पढ़े !</span>
                       
                      </div>
                  </div> */}
                </div>

                <h3 className="contentSection_subtitle">Salatut-Tasbih ki Namaz</h3>
              <div className="img title='img'Section">
                <img title='img3' src={salatTasbeeh} alt='naflNamaz3' loading='lazy'/>
                <img title='img4' src={salatTasbeeh2} alt='naflNamaz4' loading='lazy'/>
              </div>

             <h3 className="contentSection_subtitle">Shahb-E-Barat me ibadat :</h3>
             <p className="contentSection_title--content">
             sahaba-E-Kiraam ka daur, tabain aur taba tabain ka daur usme bhi is raat ki fazilat 
             se fayda uthane ka ehtimam kiya jata raha hai , log is raat me ibadat ka khusoosi 
             ehtimaam karte rhe hain, lihaza isko bid'at kahna, ya be-buniyad ya be-asl kahna bilkul 
             durust nahi, sahi baat ye hai ki ye Fazilat wali raat hai, aur is raat me ibadat karna
              baise ajro sawab hai aur iski khusoosi ahmiyat hai.baaqi apne apne naseeb ki baat hai
               ki kisko ibadat krne ka mauqa mila aur kon isse mahroom raha !
             </p>

             <p className="contentSection_title--content">
             Nafli ibadat jis qadr ho sake wo is raat me anjaam di jaye, nafl namaz padhe, Quran-E-kareem 
             ki tilawat kare , zikr kare, tasbeeh padhe, Duaae kare, al-mukhtasar jis qadr ho sake ibadat kare.
             </p>

             <p className="contentSection_title--content">
             Shaban ki 15vi shab ke hawale se Hazart Abu Musa Ash'ari se riwayat hai ki Huzoor
              صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshaad farmaya: Allah ta'ala Shaban ki 15vi shab me apni
               tamaam makhlooq ki taraf nazre rahmat farma kar unki maghfirat farma deta hai siwaaye
                un logo ke jo Allah ke sath shirk karte hain, aur jo apne dil me doosro ke khilaaf 
                keena wa bughz rakhte hain.
                <span className='referenceTag'>
                [ibne Majah: 1390]
                </span> 
              </p>

              <p className="contentSection_title--content">
              is raat ka ek paigham ye bhi hai ki ye duniya faani hai aur iski lazzate khatm hone wali 
              hain, yahi wajah hai ki Rsool-E-Akram صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم shaban ki 15vi raat Jannat-ul-baqi 
              ke qabristaan tashreef le gaye , apni ummat ke liye dua farmaayi aur ek khaamosh paigham 
              diya ki duniya ki ranginiyo'n me mubtala hokar apni qabr ko mat bhoolo jo din raat tumhe
               pukaar pukaar kar apni tanhaayi ki yaad karwa rhi hai.
              </p>

              <p className="contentSection_title--content">
              is raat ka sabse aham paigham ye hai ki Allah ta'ala gunahgaaro ko har waqt maafi dene ke liye
               tayyar hai.uski rahmat uske gazab par bhari rhti hai aur usne tauba ka darwaza har waqt khula
                rakha ha. Agar din ka gunahgaar raat ko aur raat ka gunahgaar din ko aakar uski rahmat ka
                 darwaza khatkhataye to to use yaqeenan khula hua payega.Huzoor Nabi-E-Kareem 
                 صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ka irshaad-e-giraami hai : Gunaah se tauba karne wala yu'n shumaar hota 
                 hai jaise usne koi gunaah kiya hi na ho. 
                 <span className='referenceTag'>[Bukhari Shareef]</span>
              </p>

              <p className="contentSection_title--content">
              Hazrat Ayesha Siddiqah (radi allahu anha) se riwayat hai ki Huzoor صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshaad
               farmaya : Shaban ki 15vi shab ko Allah ta'ala 15vi shaban ko Aasman-E-Duniya par nuzool farmata
                hai aur Qabeela-E-kalb ki bakriyo'n ke baalo se zyada tadaad me logo ki maghfirat farmata hai.
                <span className='referenceTag'>[Sunan Tirmizi:739]</span>
                
              </p>

              <p className="contentSection_title--content">
              in tamaam bato se maloom hua ki ye Raat bahut hi fazilat wali, Barkat wali, rahmat wali raat hai,
               yu'n to Allah ki rahmat ka darwaza hamesha hi khula rahta hai lekin Pyare Nabi صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم 
               ke irshadaat ki roshni me ye pta chalta hai ki is raat ko Allah ta'ala bando ki maghfirat aur unko 
               gunaaho se ba'rat (najaat) ka khusoosi mauqa faraham(ata) karta hai.
              </p>

              <h3 className="contentSection_subtitle">Shab-E-Barat me Qabristan jana</h3>
              <p className="contentSection_title--content">
              is raat me ek aur amal hai jo ek riwayat se sabit hai wo ye hai ki Huzoor 
              صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم Jannat-ul-Baqi (qabristan) me tashreef le gaye.
              </p>

              <p className="contentSection_title--content">
              Ummul Momineen Hazart Aisha Siddiqa (Radi Allahu Anha) irshad farmati hain ki Ek 
              raat maine Huzoor صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ko apne bistar per na paya to main Huzoor 
              صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ki talash me nikli to maine Aap صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ko jannat-ul-Baqi 
              (qabristan) me paya ki aasman ki taraf Huzoor صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne sir uthaya hua tha,
               mujhe dekh ker Aap صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne farmaya "Allah Paak Nisf Shaban (15vi Shab)
                ko Aasman-E-Duniya per jalwa'h gar hota hai aur Qabeela-E-Kalb ki Bakriyo'n ke jis qadar
                 baal hain unse zyada logo ko bakhsh deta hai."
                 <span className='referenceTag'>[ Ibne Majah : 1389 ], [Sunan Tirmizi: 739 ]</span>
              </p>

              <h3 className="contentSection_subtitle">Shabe Barat ki Fazilat</h3>
              <p className="contentSection_title--content">
              Ummul Momineen Hazart Aisha Siddiqa (Radi Allahu Anha) irshad farmati hain ki Ek raat maine 
              Huzoor صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ko apne bistar per na paya to main Huzoor صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ki 
              talash me nikli to maine Aap صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ko jannat-ul-Baqi (qabristan) me paya
               ki aasman ki taraf Huzoor صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne sir uthaya hua tha, mujhe dekh ker 
               Aap صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne farmaya "Allah Paak Nisf Shaban (15vi Shab) ko Aasman-E-Duniya
                per jalwa'h gar hota hai aur Qabeela-E-Kalb ki Bakriyo'n ke jis qadar baal hain unse zyada 
                logo ko bakhsh deta hai."
                <span className='referenceTag'>[ Ibne Majah : 1389 ], [ Sunan Tirmizi: 739 ]</span>
              </p>
              <h3 className="contentSection_subtitle">Sher-E-Khuda Hazrat Ali (Radi Allahu Anhu) se riwayat
               hai ki Huzoor ﷺ ne irshad farmaya ki :</h3>
              <p className="contentSection_title--content">
                Jab Nisf Shaban (15vi shab) aaye to usme Qiyam(Ibadat) karo aur din me Roza rakho, Beshak Allah Paak
                Ghuroob-E-Aftab se Aasman-E-Duniya per khaas tajalli farmata hai aur subah sadiq tulu hone tak kahta
                hai ki , "Hai koi mujhse maghfirat talab karne wala ki main use bakhsh du, Hai koi Rizq talab 
                karne wala ki use Rizq du, Hai koi (Musibat Ya Bimari me Mubatala) ki use Aafiyat ata karu."
                <span className='referenceTag'>(Ibne Majah : 1388)</span>
              </p>
              <p className="contentSection_title--content">
              Huzur Nabi-E-Kareem صَلَّى اللَّهُ عَلَيْهِ وَسَلَّم ne irshad farmaya ki : “ Allah Paak Shaban ki 15vi shab me 
              apni tamam makhlooq ki taraf nazre rahmat farmata hai fir Mushrik aur (musalman se ) Dushmani 
              rakhne wale ke siwa sari makhlooq ki maghfirat farma deta hai. ”
                <span className='referenceTag'>((Ibne Majah : 1390))</span>
              </p>
            

{/* in urdu nafl namaze */}
{/* <div className='nafl_namaze__section urdu_section'>
                  <h3 className="contentSection_subtitle" dir='rtl'>شب برأت کے نفل نماز</h3>
                  <div className='nafl_namaze__item contentSection-card'>
                    <div className='nafl_namaze__description'>
                        <span dir='rtl'><strong> ترکیب :</strong> ہر رکعت میں  <strong> سورہ فاتحہ (الحَمدُ شریف)</strong> کے بعد ۱ بار آیت الکرسی اور ۳ بار  سورہ اخلاص ( قُلۡ هُوَ ٱللَّهُ أَحَد) پڑھے -</span>
                        <span className='nafl_namaze__failat' dir='rtl'> <strong> فضیلت :</strong> ہر قطرہ پانی کے بدلے سات سو رکعت نفل  نماز کا ثواب ملے گا۔  
                        </span>
                    </div>
                    <span dir='rtl'>  ۲ رکعت  </span>   
                  </div>
                 
                  <div className='nafl_namaze__item contentSection-card'>
                    <div className='nafl_namaze__description'>
                        <span dir='rtl'><strong> ترکیب :</strong> ہر رکعت میں  <strong> سورہ فاتحہ (الحَمدُ شریف)</strong> کے بعد ۱ بار آیت الکرسی اور ۱۵ بار  سورہ اخلاص ( قُلۡ هُوَ ٱللَّهُ أَحَد) پڑھے -</span>
                        <span className='nafl_namaze__failat' dir='rtl'> <strong> فضیلت :</strong> ہر قطرہ پانی کے بدلے سات سو رکعت نفل  نماز کا ثواب ملے گا۔  
                        </span>
                    </div>
                    <span dir='rtl'>  ۲ رکعت  </span>   
                  </div>
                </div> */}

         
         </div>
    </div>
  )
}


export default ShabeBarat